module.exports = __webpack_public_path__ + "static/img/notext-starvan.931812f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/notext-starvan.png
// module id = nEwb
// module chunks = 1